'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ANIMATION_DELAY = 300;

var AccordionContent = function (_React$Component) {
  _inherits(AccordionContent, _React$Component);

  function AccordionContent(props) {
    _classCallCheck(this, AccordionContent);

    var _this = _possibleConstructorReturn(this, (AccordionContent.__proto__ || Object.getPrototypeOf(AccordionContent)).call(this, props));

    _this.handleScroll = function () {
      window.removeEventListener('scroll', _this.handleScroll);
      _this.renderInactiveAccordion();
    };

    _this.renderInactiveAccordion = function () {
      _this.setState({
        enableInactiveAccordion: true
      });
    };

    _this.state = {
      show: props.open,
      enableInactiveAccordion: false
    };
    return _this;
  }

  _createClass(AccordionContent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.handleScroll);
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.handleScroll();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open) {
        this.setState({
          show: true
        });
      } else {
        setTimeout(function () {
          _this2.setState({
            show: false
          });
        }, ANIMATION_DELAY);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          idx = _props.idx,
          open = _props.open,
          children = _props.children,
          style = _props.style;


      return _react2.default.createElement(
        'div',
        {
          id: 'accordion__content-' + idx,
          'aria-labelledby': 'accordion__header-' + idx,
          role: 'tabpanel',
          'aria-hidden': !open,
          className: 'accordion__content',
          style: open ? style : null,
          ref: function ref(el) {
            _this3.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          {
            className: 'accordion__content__container',
            style: { display: this.state.show || open ? 'block' : 'none' }
          },
          this.state.show || this.state.enableInactiveAccordion ? children : null
        )
      );
    }
  }]);

  return AccordionContent;
}(_react2.default.Component);

exports.default = AccordionContent;


AccordionContent.propTypes = {
  idx: _propTypes2.default.number,
  children: _propTypes2.default.node.isRequired,
  open: _propTypes2.default.bool,
  style: _propTypes2.default.shape({})
};

AccordionContent.defaultProps = {
  open: true,
  idx: 0,
  style: {}
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/accordion/jsx/AccordionContent.js
// module id = 672
// module chunks = 4